import $ from "jquery";
import axios from "axios";

(() => {
    const compare = {
        init: function () {
            $(() => {
                setTimeout(this.matchHeight, 100);
            });
            const count_cont = $('.js-compare-count');
            $('body').on('click', '.js-compare-toggle', function (e) {
                e.preventDefault();
                const $this = $(this),
                    was = $this.hasClass('active');
                axios.post(route('catalog.compare.' + (was ? 'delete' : 'add'), $this.data('id')), {_method: was ? 'DELETE' : 'POST'})
                    .then(function (response) {
                        if (response.data.status === 'ok') {
                            if (was) {
                                $this.removeClass('active');
                            } else {
                                $this.addClass('active');
                            }

                            count_cont.text(response.data.count);
                            $this.find(".catalog-category-item__action-text").text(response.data.btn_text);
                            new Noty({
                                text: response.data.message,
                                type: 'success'
                            }).show();
                        }
                    });
            });
        },
        matchHeight: function () {
            $('.compare-sidebar-row').each(function () {
                const $this = $(this),
                    id = $this.data('row'),
                    h = $('[data-mh="row-' + id + '"]').eq(0).outerHeight();
                $this.outerHeight(h);
            });
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/compare.js